import { render, staticRenderFns } from "./HeaderNews.vue?vue&type=template&id=f1f7f118&scoped=true"
import script from "./HeaderNews.vue?vue&type=script&lang=js"
export * from "./HeaderNews.vue?vue&type=script&lang=js"
import style0 from "./HeaderNews.vue?vue&type=style&index=0&id=f1f7f118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f7f118",
  null
  
)

export default component.exports